/**
 * Auto-select 3pk option after 2 second delay on PDP and Quick Shop
 * Following reference script logic pattern
 */
(function() {
  'use strict';

  const DELAY_MS = 2000; // 2 seconds
  const MATCH_REGEX = /(\b|\s)3\s*-?\s*pk\b|\b3\s*-?\s*pack\b/i;

  /**
   * Check if URL has variant parameter
   */
  function hasVariantParam() {
    try {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.has('variant') && urlParams.get('variant');
    } catch (e) {
      return false;
    }
  }

  /**
   * Start auto-select process following reference script logic
   */
  function startAutoSelect3pk(container) {
    if (!container) return;

    try {
      // Check if variant is already in URL
      if (hasVariantParam()) {
        return;
      }

      // Find variant-selects element
      var variantSelects = container.querySelector('variant-selects[data-section], variant-radios[data-section]');
      if (!variantSelects) {
        variantSelects = container.querySelector('variant-selects, variant-radios');
      }
      if (!variantSelects) return;

      // Get section ID for unique identification
      var sectionId = variantSelects.dataset.section || variantSelects.id.replace('variant-selects-', '').replace('variant-radios-', '');
      
      // Find all radio inputs (variant options)
      var inputs = variantSelects.querySelectorAll('input[type="radio"]');
      if (!inputs || !inputs.length) return;

      // Find the 3pk option
      var matchRegex = MATCH_REGEX;
      var preselectTarget = null;

      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        var val = (inp && inp.value) ? String(inp.value).trim() : '';
        var disabled = inp.classList.contains('disabled') || inp.disabled;

        if (!disabled && matchRegex.test(val)) {
          preselectTarget = inp;
          break;
        }
      }

      // Also check label text if not found by value
      if (!preselectTarget) {
        for (var i = 0; i < inputs.length; i++) {
          var inp = inputs[i];
          var disabled = inp.classList.contains('disabled') || inp.disabled;
          if (disabled) continue;

          var label = container.querySelector('label[for="' + inp.id + '"]');
          if (label) {
            var labelText = label.textContent.trim();
            if (matchRegex.test(labelText)) {
              preselectTarget = inp;
              break;
            }
          }
        }
      }

      if (!preselectTarget) return;

      // Visually reflect selection immediately without triggering change logic yet
      if (!preselectTarget.checked) {
        preselectTarget.checked = true;
      }

      // Get product ID for unique timer/cancel flags
      // Use a combination that's unique per modal/section instance
      var productSection = container.closest('section[id^="MainProduct-"]');
      var modalContent = container.closest('[id^="QuickAddInfo-"]');
      var modalId = modalContent ? modalContent.id : (container.id || '');
      var productId = (modalId || (productSection ? (productSection.id || sectionId) : 'default')) + '_' + Date.now();
      
      var timerKey = '__autoSelect3pk_timer_' + productId;
      var cancelKey = '__autoSelect3pk_cancelled_' + productId;

      // Cancel function
      function cancelScheduled() {
        window[cancelKey] = true;
        if (window[timerKey]) {
          clearTimeout(window[timerKey]);
          window[timerKey] = null;
        }
        inputs.forEach(function(el) {
          el.removeEventListener('change', cancelScheduled);
        });
      }

      // Set up cancellation listeners on all inputs
      inputs.forEach(function(el) {
        el.addEventListener('change', cancelScheduled, { once: true });
      });

      window[cancelKey] = false;

      // Schedule the actual change event trigger after delay
      window[timerKey] = setTimeout(function() {
        if (!window[cancelKey] && preselectTarget) {
          initAutoSelect3pk(container, preselectTarget);
        }
      }, DELAY_MS);

    } catch (e) {
      // fail silently
      console.error('Auto-select 3pk error:', e);
    }
  }

  /**
   * Trigger the actual change event (following reference script logic)
   */
  function initAutoSelect3pk(container, targetInput) {
    if (!container || !targetInput) return;

    try {
      // Check if variant is already in URL
      if (hasVariantParam()) {
        return;
      }

      // Ensure it's checked
      if (!targetInput.checked) {
        targetInput.checked = true;
      }

      // Dispatch change event
      var evt = new Event('change', { bubbles: true });
      targetInput.dispatchEvent(evt);

      // Also try clicking the label
      var label = container.querySelector('label[for="' + targetInput.id + '"]');
      if (label) {
        label.click();
      }

    } catch (e) {
      // fail silently
      console.error('Auto-select 3pk init error:', e);
    }
  }

  /**
   * Initialize for PDP
   */
  function initPDP() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(function() {
          var productSection = document.querySelector('section[id^="MainProduct-"]');
          if (productSection) {
            startAutoSelect3pk(productSection);
          }
        }, 500);
      }, { once: true });
    } else {
      setTimeout(function() {
        var productSection = document.querySelector('section[id^="MainProduct-"]');
        if (productSection) {
          startAutoSelect3pk(productSection);
        }
      }, 500);
    }
  }

  /**
   * Initialize for Quick Shop modal
   */
  function initQuickShop() {
    // Listen for custom event from quick-add.js
    document.addEventListener('quickadd:contentLoaded', function(event) {
      if (event.detail && event.detail.modalContent) {
        // Wait for scripts to be reinjected and variant-selects to initialize
        setTimeout(function() {
          // Check if content is actually loaded
          var variantSelects = event.detail.modalContent.querySelector('variant-selects, variant-radios');
          if (variantSelects) {
            startAutoSelect3pk(event.detail.modalContent);
          } else {
            // Retry after a bit more time
            setTimeout(function() {
              startAutoSelect3pk(event.detail.modalContent);
            }, 500);
          }
        }, 800);
      }
    });

    // Watch for modal open attribute changes (when modal is shown)
    function setupModalWatcher() {
      var modals = document.querySelectorAll('quick-add-modal');
      modals.forEach(function(modal) {
        // Skip if already has observer
        if (modal.dataset.autoSelectObserver) return;
        modal.dataset.autoSelectObserver = 'true';
        
        // Watch for open attribute changes
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
              if (modal.hasAttribute('open')) {
                // Modal just opened, wait for content to load
                setTimeout(function() {
                  var modalContent = modal.querySelector('[id^="QuickAddInfo-"]');
                  if (modalContent && modalContent.innerHTML.trim() !== '') {
                    // Wait a bit more for scripts to execute
                    setTimeout(function() {
                      startAutoSelect3pk(modalContent);
                    }, 1000);
                  }
                }, 500);
              } else {
                // Modal closed - clear any pending timers for this modal
                var modalContent = modal.querySelector('[id^="QuickAddInfo-"]');
                if (modalContent) {
                  var modalId = modalContent.id;
                  // Clear any timers related to this modal
                  for (var key in window) {
                    if (key.startsWith('__autoSelect3pk_') && key.includes(modalId)) {
                      if (window[key] && typeof window[key] === 'number') {
                        clearTimeout(window[key]);
                      }
                      delete window[key];
                    }
                  }
                }
              }
            }
          });
        });

        observer.observe(modal, {
          attributes: true,
          attributeFilter: ['open']
        });
      });
    }

    // Also watch for quick-add modal content changes as fallback
    function setupMutationObserver() {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if it's a quick-add modal content
              if (node.id && node.id.startsWith('QuickAddInfo-')) {
                // Wait for content to be populated
                setTimeout(function() {
                  if (node.innerHTML.trim() !== '') {
                    startAutoSelect3pk(node);
                  }
                }, 1000);
              }
              // Also check for variant-selects being added
              var variantSelects = node.querySelector && node.querySelector('variant-selects, variant-radios');
              if (variantSelects) {
                var modalContent = variantSelects.closest('[id^="QuickAddInfo-"]');
                if (modalContent) {
                  setTimeout(function() {
                    startAutoSelect3pk(modalContent);
                  }, 1000);
                }
              }
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    // Initialize watchers
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setupModalWatcher();
        setupMutationObserver();
      });
    } else {
      setupModalWatcher();
      setupMutationObserver();
    }

    // Also watch for new modals being added dynamically
    var modalObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.tagName === 'QUICK-ADD-MODAL') {
            setupModalWatcher();
          }
        });
      });
    });

    modalObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize
  initPDP();
  initQuickShop();

})();
